<template>
  <el-card class="box-card" body-style="padding: 0px">
    <div slot="header" class="clearfix">
      <el-row :gutter="10">
        <el-col :sm="12" :xs="24">
          <span>{{ this.isValidTitle }}</span>
        </el-col>
        <el-col :sm="12" :xs="24" style="text-right">
          <label for="upload-file" class="btn-csv-import pull-right" @click="showImport" v-if="permission.can('write', 'csvcoupon') && isVisibleCsv">CSVインポート
          </label>
          <el-button class="btn-plus" style="float: right" type="success" icon="el-icon-plus" @click="addNewClinicCoupon" v-if="permission.can('write', 'coupon')">
            新規登録する
          </el-button>
          <el-button class="btn-plus" style="float: right" type="success" @click="switchIsValid">
            表示切り替え
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div class="clearfix">
      <el-table :data="clinicCoupons" border fit highlight-current-row style="width: 100%" @row-click="rowClicked" empty-text="該当結果が見つかりません。"
      >
        <el-table-column
          prop="purchase_date"
          sortable
          label="購入日"
          min-width="130px"
        />
        <el-table-column
          prop="menu_coupon_name"
          sortable
          label="回数券名"
          min-width="130px"
        />
        <el-table-column
          prop="customer"
          sortable
          min-width="130px"
          label="名前"
        >
          <template slot-scope="scope">
            {{ scope.row.clinic_customer_note.full_name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="therapists"
          min-width="130px"
          sortable
          label="担当者"
          className="therapist-column"
        >
          <template slot-scope="scope">
            <div class="truncate-name" >
              <div v-for="therapist in scope.row.therapistsToShow" :key="therapist.id" >
                {{therapist.name}}
              </div>
            </div>
            <el-button type="info" @click.stop.prevent @click="showTherapistsModal(scope.row.id, scope.row.therapists)" 
              :disabled="scope.row.therapistsToShow.length < 2 || (scope.row.clinic.id != currentClinic.id && !permission.can('write_all', 'coupon'))">
              予約優先順
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="clinic"
            label="店舗名"
            min-width="130px"
        >
          <template slot-scope="scope">
            {{ scope.row.clinic.clinic_name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="used_per_total"
          min-width="130px"
          sortable
          label="利用状況"
        >
        </el-table-column>
        <el-table-column
          prop="last_treatment"
          min-width="130px"
          sortable
          label="最終来店"
        >
        </el-table-column>
        <el-table-column
          prop="expiry_date"
          min-width="130px"
          sortable
          label="有効期間"
        >
          <template slot-scope="scope">
            {{ scope.row.time_limit_flag ? scope.row.expiry_date : ''}}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>
<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import permissionService from "../../../services/permission_service";
  export default {
    computed: {
      ...mapGetters(['clinicMenuCoupons', 'clinicCoupons', 'clinicCoupon', 'newClinicCoupon', "clinicCustomerNotes", 'queryClinicCoupon', 'dropdownMenuCoupons', 'editClinicCoupon', 'isVisibleCsv', 'currentClinicCustomerNotes', 'therapists', 'currentClinic']),
      isValidTitle() {
        return this.queryClinicCoupon.isValid ? '回数券管理' : '消化済み回数券の管理'
      }
    },
    methods: {
      ...mapActions('clinic_coupon', ['fetchClinicCoupons', 'getClinicCoupon']),
      ...mapActions('clinic_customer_note', ['fetchClinicCustomerNotes']),
      ...mapActions('therapist', ['fetchTherapists']),
      ...mapActions('menu_coupon', ['fetchClinicMenuCoupons']),
      ...mapMutations('clinic_customer_note', ['ADD_NOTES']),
      ...mapMutations('clinic', ['SET_CLINIC_CUSTOMER_NOTE']),
      ...mapMutations('therapist', ['SET_THERAPISTS']),
      ...mapMutations('menu_coupon', ['SET_DROPDOWN_MENU_COUPONS', 'SET_CLINIC_MENU_COUPON']),
      ...mapMutations('clinic_coupon', ['SET_CLINIC_COUPON_VISIBLE', 'SET_EDIT_CLINIC_COUPON', 'SET_CLINIC_COUPON_IS_EDIT', 'SET_IS_VALID', 'SET_THERAPISTS_MODAL_VISIBLE', 'SET_THERAPISTS_TO_SORT', 'SET_CSV_VISIBLE', 'SET_CLINIC_COUPON_IS_EDIT_POSITION']),

      async addNewClinicCoupon() {
        this.SET_CLINIC_COUPON_VISIBLE(true)
        this.SET_CLINIC_COUPON_IS_EDIT(false)
        this.SET_EDIT_CLINIC_COUPON(this.newClinicCoupon)
        this.SET_CLINIC_CUSTOMER_NOTE([])
        this.SET_CLINIC_MENU_COUPON([])
        this.SET_THERAPISTS([])
        if (!this.permission.can('write_all', 'coupon') && this.permission.can('write', 'coupon')) {
          await this.fetchClinicCustomerNotes({clinic_id: this.currentClinic.id})
          this.fetchTherapists(this.currentClinic.id)
          this.fetchClinicMenuCoupons(this.currentClinic.id)
        }
      },
      showImport() {
        this.SET_CSV_VISIBLE(true)
      },
      async rowClicked(row) {
        await this.getClinicCoupon(row.id)
        this.SET_CLINIC_COUPON_IS_EDIT(true)
        this.SET_EDIT_CLINIC_COUPON(this.clinicCoupon)
        if (this.clinicCoupon.used_times == 0 &&
            this.permission.can('write', 'coupon') &&
            (this.clinicCoupon.clinic.id == this.currentClinic.id || this.permission.can('write_all', 'coupon'))){
          await this.fetchDataWhenShow(this.clinicCoupon)
        }
        this.SET_CLINIC_COUPON_VISIBLE(true)
      },

      async fetchDataWhenShow(clinicCoupon) {
        await Promise.all([
          this.fetchTherapists(clinicCoupon.clinic.id),
          this.fetchClinicMenuCoupons(clinicCoupon.clinic.id),
        ]);
        this.handleClinicMenuCoupons(clinicCoupon)
        this.fetchClinicCustomerNotes({ clinic_id: clinicCoupon.clinic.id })
      },

      switchIsValid() {
        this.SET_IS_VALID(!this.queryClinicCoupon.isValid)
        this.fetchClinicCoupons()
      },

      showTherapistsModal(clinic_coupon_id, therapists) {
        this.SET_THERAPISTS_MODAL_VISIBLE(true)
        this.SET_THERAPISTS_TO_SORT(therapists)
        this.SET_CLINIC_COUPON_IS_EDIT_POSITION(clinic_coupon_id)
      },
      showModal() {
        let element = this.$refs.modal.$el
        $(element).modal('show')
      },
      handleClinicMenuCoupons(clinicCoupon) {
        // check if menu_coupon is deleted, get the current data and add to clinicMenuCoupons to open Modal
        if (this.clinicMenuCoupons.every(menu_coupon => menu_coupon.id != clinicCoupon.menu_coupon_id)) {
          this.clinicMenuCoupons.unshift(
            {
              id: clinicCoupon.menu_coupon_id,
              name: clinicCoupon.menu_coupon_name,
              duration: clinicCoupon.duration,
              unitprice: clinicCoupon.price,
              total_uses: clinicCoupon.total_uses 
            }
          )
        } 
      }
    },
    data() {
      return {
        permission: permissionService
      }
    },
  }
</script>
<style>
  th .cell, .el-table .sort-caret.ascending {
    color: #51cbce;
  }

  .therapist-column .cell {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
</style>
